import React, { useEffect } from "react";
import failureImage from "../../assets/remove.webp";
import { useNavigate } from "react-router";

function AlertFailurePopup() {
  // Block background scrolling when modal is open
  const navigate = useNavigate();
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  // Handle outside click
  const handleOutsideClick = (e) => {
    if (e.target === e.currentTarget) {
      //   onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm"
      onClick={handleOutsideClick}
    >
      <div className="relative bg-white rounded-2xl shadow-xl p-8 mx-4 w-full max-w-md animate-scale-in">
        {/* Close button */}
        {/* <button
          onClick={onClose}
          className="absolute top-4 right-4 p-1 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button> */}

        {/* Content */}
        <div className="flex flex-col items-center">
          <div className="relative mb-6">
            <img
              src={failureImage}
              alt="Failure Icon"
              className="w-20 h-20 object-contain animate-shake"
            />
            <div className="absolute inset-0 rounded-full bg-red-100 opacity-20 -z-10"></div>
          </div>

          <h2 className="text-2xl font-bold text-gray-800 mb-2 text-center">
            Payment <span className="text-purple-600">Unsuccessful</span>
          </h2>

          <p className="text-gray-600 mb-4 text-center">
            We encountered an issue processing your payment.
          </p>

          <div className="w-full bg-purple-50 rounded-lg p-4 mb-6 border border-purple-100">
            <p className="text-purple-800 font-medium text-center">
              Please check your payment details and try again.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 w-full">
            <button
              className="flex-1 px-4 py-3 bg-gradient-to-r from-purple-600 to-purple-500 hover:from-purple-700 hover:to-purple-600 text-white font-medium rounded-lg shadow-md transition-all duration-300 flex items-center justify-center"
              onClick={() => navigate("/pricing")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
                  clipRule="evenodd"
                />
              </svg>
              Retry Payment
            </button>
            <button
              className="flex-1 px-4 py-3 border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium rounded-lg transition-all duration-300"
              onClick={() => navigate("/")}
            >
              Home
            </button>
          </div>
        </div>

        {/* Support link */}
        <div className="mt-6 pt-6 border-t border-gray-100 text-center">
          <p className="text-sm text-gray-500 mb-2">Still having trouble?</p>
          <button
            onClick={() =>
              window.open("https://selfsync.ai/contact-us", "_blank")
            }
            className="text-purple-600 hover:text-purple-800 font-medium text-sm inline-flex items-center"
          >
            Contact Support
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 ml-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

export default AlertFailurePopup;
